<div [class.hidden]="GrowerSearchSliderActive">
  <div class="order-transfer-inner ">
    <div class="order-trans-top">
      <div class="order-trans-form">
        <h2>Grower Order Transfer:</h2>
        <div class="row">
          <div class=" col-md-12 sellerDropDown material-select">
            <ng-select name="ddlG2GSeller"
                       [items]="sellerData"
                       class="custom-select-grower grower-add-drop"
                       [(ngModel)]="toSellerId"
                       [virtualScroll]="true"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Updated Seller:"
                       [loading]="accountLoading"
                       [closeOnSelect]="true"
                       (change)="SellerChange($event)"
                       [searchFn]="sellerSearchFn">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <!--<b [ngOptionHighlight]="search"></b>-->
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="row" *ngIf="isSubscriptionAccess">
          <div class="col-md-12">
            <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
              <mat-label>Non-Subscriber Email:</mat-label>
              <input matInput type="email" name="accountEmail"
                     placeholder="(Separate multiple email addresses by a semi-colon)"
                     [(ngModel)]="accountEmail"
                     [pattern]="emailPattern"
                     (keyup)="validateEmail()"
                     email="true">
              <mat-error *ngIf="isNotValid">
                This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="order-box-outer">
        <div class="row">
          <div class="col-md-12  text-center">
            <div class="order-box card text-center">
              <div class="card-body">
                <h5 class="card-title">Order</h5>
                <p class="card-text">{{fromGrower?.growerOrderList[0].orderNumber}}</p>
              </div>
            </div>
            <div class="order-box card text-center">
              <div class="card-body">
                <h5 class="card-title">Order</h5>
                <p class="card-text">{{toGrower == null ? '' : (toGrower?.growerOrderList.length > 0 ? toGrower?.growerOrderList[0].orderNumber :'New Order')}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row order-box-bottom">
          <div class="col-md-6">
            <div class="orderText fromOrder">
              <span>
                from:
              </span>
              <i class="fas fa-caret-up"></i>
            </div>
          </div>
          <div class="col-md-6">
            <div class="orderText toOrder">
              <span>
                to:
              </span>
              <i class="fas fa-caret-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="transferSec">
      <div class="row">
        <div class="col-md-12">
          <div class="tableContainer margBottom">
            <table class="matTables productTable mat-table">
              <thead>
              <th colspan="3" class="borderR" valign="top">
                <div class="leftColTransfer ">
                  <div class="growerInfo">
                    <h4>
                      {{fromGrower?.businessName}}
                    </h4>
                    <p class="accountName">
                      {{accountInfo?.accountName}}, {{accountInfo?.city}} - {{accountInfo?.state}}
                    </p>
                    <p class="address">
                      {{fromGrower?.address1}}
                    </p>
                    <p class="address">
                      {{fromGrower?.city}} {{fromGrower?.state}} {{fromGrower?.zip}}
                    </p>
                  </div>
                </div>
              </th>
              <th colspan="2">
                <div class="rgtColTransfer padding-r0 padding-l0">
                  <div class="growerInfoTo">
                    <div class="row">
                      <div class="col-md-1 padding-l0 padding-r0 borderBot"><span class="toText">TO:</span> </div>
                      <div class=" col-md-11 padding-l0 material-select toGrowerSelectOuter borderBot">
                        <ng-select name="ddlG2GToGrower"
                                   [items]="toGrowerList"
                                   class="custom-select-grower grower-add-drop toGrowerInfo"
                                   [(ngModel)]="selectedGrower"
                                   [virtualScroll]="true"
                                   bindLabel="businessName"
                                   bindValue="gmk"
                                   placeholder="Type here to find a transfer target"
                                   [loading]="accountLoading"
                                   [closeOnSelect]="true"
                                   (change)="selectToGrower($event)"
                                   [searchFn]="toGrowerSearchFn">
                          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <!--<b [ngOptionHighlight]="search"></b>-->
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <h4 class="name greenColor" [ngOptionHighlight]="search">
                                    {{item.businessName}}
                                  </h4>
                                  <p class="address" [ngOptionHighlight]="search">
                                    {{item.address1}}, {{item.city}}, {{item.state}} - {{item.zip}}
                                  </p>
                                  <p class="phoneNo" [ngOptionHighlight]="search">
                                    {{item.primaryPhoneNumber}}
                                  </p>
                                </div>
                                <div class="col-md-4 orderId-detail text-right">
                                  Order:
                                  <p [ngOptionHighlight]="search">{{item.growerOrderList?.length > 0 ? item.growerOrderList[0].orderNumber : ""}}</p>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <p class="glnNo" [ngOptionHighlight]="search">
                                    Grower GMK: {{item.gmk}}
                                  </p>
                                </div>
                                <div class="col-md-6 text-right">
                                  <p class="glnNo" [ngOptionHighlight]="search">
                                    Grower GLN: {{item.growerGLN}}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                            <div class="ng-option disabled">
                              No data found for "{{searchTerm}}"
                            </div>
                          </ng-template>
                          <ng-template ng-footer-tmp let-search="searchTerm">
                            <div class="custom-drop-footer">
                              <div class="row">
                                <div class="col-md-8">
                                  <button mat-raised-button class="btns" color="primary" (click)="openSearchGrowerSlider()">Advanced Search</button>
                                </div>
                                <div class="col-md-4 bold text-right padding-r25">
                                  {{toGrowerList?.length}} Results
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <div class="growerInfoToDetails">
                    <div class="row">
                      <div class="col-md-1">&nbsp;</div>
                      <div class="col-md-11 padding-l0">
                        <div class="growerInfo padding-0">
                          <p *ngIf="toGrower" class="accountName margin-t5">
                            {{accountInfo?.accountName}}, {{accountInfo?.city}} - {{accountInfo?.state}}
                          </p>
                          <p class="accountName mediumFont">
                            {{toGrower?.address1}}
                          </p>
                          <p class="address">
                            {{toGrower?.city}} {{toGrower?.state}} {{toGrower?.zip}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              </thead>
              <thead>
                <tr class="mat-header-row">
                  <th class="mat-header-cell origProductName">Product</th>
                  <th class="mat-header-cell text-center originalUnit">Original</th>
                  <th class="mat-header-cell text-center modifiedUnit borderR">Remaining</th>
                  <th class="mat-header-cell replacedProductName">Product</th>
                  <th class="mat-header-cell text-center editUnit">Units</th>
                </tr>
              </thead>
              <tbody *ngFor="let g2g of copyOrderFromToList">
                <tr class="mat-row">
                  <td class="order-info mat-cell origProdNameContent">
                    <p matTooltip="{{g2g.Brand}} - {{g2g.MarketingBrand}}" [matTooltipPosition]="'above'" [attr.data-testid]="g2g.ItemNumber">{{g2g.Brand}} - {{g2g.MarketingBrand}}</p>
                    <p class="grower-name" matTooltip="{{g2g.ItemDescription}}" [matTooltipPosition]="'above'">{{g2g.ItemDescription}}</p>
                    <p *ngIf="g2g.seedNonReturnable" class="grower-name nonReturnable">*NON-RETURNABLE</p>
                  </td>
                  <td class="text-center mat-cell font-18">
                    {{commonService.getFormatedNumber(g2g.OriginalFromQty)| number}}
                  </td>
                  <td class="text-center mat-cell font-18 borderR">
                    <!--{{g2g.FromModifyQty}}-->
                    {{commonService.getFormatedNumber(+g2g.OriginalFromQty - +g2g.ToPrimaryQty) | number}}
                  </td>
                  <td class="order-info mat-cell">
                    <p>{{g2g.Brand}} - {{g2g.MarketingBrand}}</p>
                    <p class="grower-name">{{g2g.ItemDescription}}</p>
                  </td>
                  <td class="text-center mat-cell ">
                    <div>
                      <button (click)="geuValueChange('decrease',g2g);g2g.isSelected=true" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + g2g.ItemNumber"> - </button>
                      <input type="text" class="geu-txt" id="txtUnits" [(ngModel)]="g2g.ToPrimaryQty" (focusout)="validateSelectedCount(g2g, $event.target.value)" maxlength="9" appThreeDigitDecimaNumber [attr.data-testid]="'qty-' + g2g.ItemNumber" />
                      <button (click)="geuValueChange('increase',g2g); g2g.isSelected=true" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + g2g.ItemNumber"> + </button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="g2g && g2g.LineErrors.errors.length > 0" id="error_{{g2g.LineErrors.rowId}}">
                  <td colspan="5">
                    <div class="inline-error">
                      <div class="row">
                        <div class="col-md-12">
                          <ol class="error-list">
                            <li *ngFor="let err of g2g.LineErrors.errors" class="justify-content-center align-self-center">
                              {{err.error }}
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="tableTotalsSec">
      <div class="row">
        <div class="col-md-7">
          <button mat-raised-button class="btns" color="primary" [disabled]="!isTransfer || modifiedUnitCount<=0 || isNotValid==true" (click)="transferUnits()">Transfer Units</button>
          <a style="cursor:pointer" (click)="onCancel()">Cancel </a>
        </div>
        <div class="col-md-5 text-right count">
          Transferred Units:
          <span>
            {{(commonService.getFormatedNumber(modifiedUnitCount) | number)}}/{{(commonService.getFormatedNumber(originalUnitCount) | number)}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<app-grower-search [class.hidden]="!GrowerSearchSliderActive" [GrowerSearchSliderActive]="GrowerSearchSliderActive" [usedAsNestedComp]="true"></app-grower-search>
